export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCstDrWeFDDRSZIeqH1MTs-dSUwAWZbuEY',
    authDomain: 'atua-copilot-dev.firebaseapp.com',
    projectId: 'atua-copilot-dev',
    storageBucket: 'atua-copilot-dev.firebasestorage.app',
    messagingSenderId: '804105846620',
    appId: '1:804105846620:web:9163af773ce22b5ec0cb99',
    measurementId: 'G-SQD0BQK679',
    vapidKey: 'BBimKlVIgRCabQC3vGkfAV8TRl4VJNWsnNsm7oQZwhCYSZDhrJtQij0IFrQuQ4Iqf8mIoYCdTGDrf5aXNuBqpGY'
  },
  clientBaseUrl: 'https://atua-copilot-client-dev.web.app/',
};
